import { Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from '@angular/core';
import { LandingChain } from '@box-types';
import { generateImageSrc } from '@box/utils';

@Component({
  selector: 'landing-chain',
  templateUrl: './landing-chain.component.html',
  styleUrls: ['./landing-chain.component.scss']
})
export class LandingChainComponent implements OnInit {
  @Input() public landingBrand: LandingChain;
  @Output() private selectBrand: EventEmitter<LandingChain> = new EventEmitter<LandingChain>();

  public backgroundImage: string;
  public backgroundAlt: string;
  public logo: string;
  public logoAlt: string;
  public name: string;

  @HostBinding('class') public hostName = 'landing-brand';
  @HostListener('click', ['$event']) public onClick(): void {
    this.selectBrand.emit(this.landingBrand);
  }

  ngOnInit(): void {
    this.name = this.landingBrand.name;
    this.backgroundImage = generateImageSrc(this.landingBrand.backgroundImage);
    this.backgroundAlt = this.landingBrand.name;
    this.logo = generateImageSrc(this.landingBrand.logo);
    this.logoAlt = this.landingBrand.name + ' logo';
  }
}
